import React from 'react';
import '../../css/about.css';

const Terms = () => {
  const lastUpdated = 'June 16, 2026';

  return (
    <div className="about-page">
      <section className="about-section">
        <div className="container" style={{ maxWidth: '760px' }}>
          <h1>Terms of Service</h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
            Last updated: {lastUpdated}
          </p>

          <p>
            These Terms of Service ("Terms") govern your use of UnsupervisedBias and its affiliated
            products, including <a href="https://pdubfantasy.com" style={{ color: 'var(--pink)' }}>PdubFantasy</a>.
            By accessing or using our services, you agree to these Terms. If you do not agree, please
            do not use our services.
          </p>

          <h2>1. Who we are</h2>
          <p>
            UnsupervisedBias is an independent technology and media company based in Washington, DC,
            focused on AI research, data science, and fan-driven sports technology. Our products include
            this website, the PdubFantasy PWHL fantasy hockey platform, and related content and tools.
          </p>

          <h2>2. Eligibility</h2>
          <p>
            You must be at least 13 years old to use our services. If you are between 13 and 18,
            you may only use the services with a parent or guardian's consent. By registering, you
            confirm that you meet this requirement and that all information you provide is accurate.
          </p>

          <h2>3. User accounts</h2>
          <ul>
            <li>You may create one account per person. You are responsible for all activity under your account.</li>
            <li>Keep your login credentials confidential. Notify us immediately if you suspect unauthorized access.</li>
            <li>We may suspend or terminate accounts that violate these Terms.</li>
            <li>You may delete your account at any time via Account Settings or by emailing{' '}
              <a href="mailto:support@unsupervisedbias.com" style={{ color: 'var(--pink)' }}>support@unsupervisedbias.com</a>.
            </li>
          </ul>

          <h2>4. User-generated content</h2>
          <p>
            You may submit content on our platforms, including blog comments, profile information,
            fantasy league names, and other user-created material ("User Content"). You retain ownership
            of your User Content. By submitting it, you grant us a non-exclusive, worldwide, royalty-free
            license to use, display, and store it solely to operate and improve the service.
          </p>
          <p>
            You are solely responsible for your User Content. You agree not to post content that is
            illegal, harassing, hateful, or that infringes third-party intellectual property rights.
            We may remove any User Content at our discretion.
          </p>

          <h2>5. Intellectual property</h2>
          <p>
            The UnsupervisedBias name, logo, website design, and original content (articles, tools,
            software) are the property of UnsupervisedBias. You may not reproduce or redistribute them
            without our written permission.
          </p>
          <p>
            Third-party data, logos, and trademarks displayed on our platforms remain the property of
            their respective owners and are used for informational and entertainment purposes only.
            Where applicable, we have sought or are seeking permission for such use.
          </p>

          <h2>6. Prohibited conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use our services for any illegal purpose or in violation of applicable law.</li>
            <li>Harass, bully, or threaten other users or individuals.</li>
            <li>Use automated scripts, bots, or scrapers to access our services without written permission.</li>
            <li>Attempt to access accounts, systems, or data you are not authorized to access.</li>
            <li>Submit malicious code, viruses, or content designed to disrupt the service.</li>
            <li>Impersonate UnsupervisedBias staff, affiliated partners, or other users.</li>
            <li>Use our services to promote or sell products without our prior written consent.</li>
          </ul>

          <h2>7. Third-party links and services</h2>
          <p>
            Our platforms may contain links to third-party websites and services (including affiliate
            links for merchandise). These links are provided for your convenience; we do not control
            and are not responsible for third-party content, privacy practices, or services. Affiliate
            links are disclosed at the point of use and earn us a small commission at no additional
            cost to you.
          </p>

          <h2>8. Disclaimer of warranties</h2>
          <p>
            Our services are provided <strong>"as is"</strong> and <strong>"as available"</strong> without
            warranties of any kind. We do not guarantee that our services will be uninterrupted or
            error-free. Statistics, scores, and data are sourced from third parties and may contain
            errors or delays — we disclaim all liability for their accuracy.
          </p>

          <h2>9. Limitation of liability</h2>
          <p>
            To the maximum extent permitted by law, UnsupervisedBias is not liable for any indirect,
            incidental, special, consequential, or punitive damages arising from your use of our
            services, even if we have been advised of the possibility of such damages. Our aggregate
            liability for any claim is limited to the greater of (a) the amount you paid us in the
            12 months preceding the claim, or (b) $10 USD.
          </p>

          <h2>10. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless UnsupervisedBias from any claims, damages, or
            expenses (including reasonable attorneys' fees) arising from your use of our services,
            your User Content, or your violation of these Terms.
          </p>

          <h2>11. Termination</h2>
          <p>
            You may stop using our services at any time. We may suspend or terminate your access for
            violation of these Terms. Upon termination, your right to use the service ends immediately.
            Provisions that by their nature survive termination (including disclaimers and limitation
            of liability) will remain in effect.
          </p>

          <h2>12. Governing law and disputes</h2>
          <p>
            These Terms are governed by the laws of Washington, DC, United States, without regard to
            conflict-of-law principles. Any dispute arising out of these Terms shall be resolved through
            binding arbitration under the rules of the American Arbitration Association, except that
            either party may seek injunctive relief in a court of competent jurisdiction. You waive
            any right to a class-action lawsuit or class-wide arbitration.
          </p>

          <h2>13. Changes to these Terms</h2>
          <p>
            We may update these Terms from time to time. Material changes will be communicated via a
            notice on the site or by email. Your continued use of our services after the effective
            date constitutes acceptance of the revised Terms.
          </p>

          <h2>14. Contact</h2>
          <p>
            Questions about these Terms:{' '}
            <a href="mailto:support@unsupervisedbias.com" style={{ color: 'var(--pink)' }}>
              support@unsupervisedbias.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Terms;
